import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';

const MenuUniformesSec = ({link}) => {

    const navigate = useNavigate();

    const nestedMenuitems = [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-line',
            command: e => {
                navigate('/dashboard');
            }
        }, {
            label: 'Filtro',
            icon: 'pi pi-search',
            command: e => {
                navigate('/filtro/na');
            }
        }, {
            label: 'Pendientes',
            icon: 'pi pi-cog',
            command: e => {
                navigate('/pendientes');
            }
        },
        {
            label: 'Validación',
            icon: 'pi pi-fw pi-pencil',
            command: e => {
                navigate('/validacion');
            }
        },
        {
            label: 'Reportes',
            icon: 'pi pi-fw pi-cog',
            items: [{
                label: 'General',
                icon: 'pi pi-fw pi-file-pdf',
                command: e => {
                    navigate('/reporte-general');
                }
            }, {
                label: 'Bitácora',
                icon: 'pi pi-fw pi-paperclip',
                command: e => {
                    navigate('/reporte/corte-administrador');
                }
            }]
        }
    ];

    return (
        <div className="col-12" style={{marginBottom: "15px"}}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuUniformesSec;